var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.963 0.5H5.22433C4.67279 0.5 4.22412 0.9487 4.22412 1.50021V3.84777H5.13716V1.50021C5.13716 1.45215 5.17627 1.41304 5.22433 1.41304H12.963C13.0111 1.41304 13.0502 1.45215 13.0502 1.50021V9.23892C13.0502 9.28701 13.0111 9.32612 12.963 9.32612H10.6887V10.2392H12.963C13.5146 10.2392 13.9633 9.79046 13.9633 9.23892V1.50021C13.9632 0.9487 13.5146 0.5 12.963 0.5Z",
    fill: "#98B1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77554 4.76082H1.03686C0.485321 4.76082 0.0366211 5.20952 0.0366211 5.76106V13.4998C0.0366515 14.0513 0.485321 14.5 1.03686 14.5H8.77557C9.32711 14.5 9.77581 14.0513 9.77581 13.4998V5.76106C9.77584 5.20952 9.32708 4.76082 8.77554 4.76082ZM8.77561 13.587H1.03686C0.988773 13.587 0.949665 13.5479 0.949665 13.4998V5.76106C0.949665 5.71297 0.988773 5.67386 1.03686 5.67386H8.77557C8.82366 5.67386 8.86277 5.71297 8.86277 5.76106V13.4998H8.8628C8.8628 13.5479 8.82366 13.587 8.77561 13.587Z",
    fill: "#98B1F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.df490762.svg";
export { ForwardRef as ReactComponent };